import React from 'react'
import Classes from './styles/style.module.css'
import Navbar from '../Home/Components/Navbar/Navbar'
import Footer from '../../GlobalComp/Footer/Footer';
import { Helmet } from 'react-helmet-async';

export default function TermsOfService() {

    return (
        <>
            <form className={Classes.hero} >
                <Helmet>
                    <title>Terms of Service | Quick Vents and Appliance Repair</title>
                    <meta name="description"
                        content="Terms of Service for Quick Vents and Appliance Repair, providing dryer vent cleaning and appliance repair in Palm Beach and Broward Counties, FL." />
                    <link rel="canonical" href="https://www.quickvents.com/terms-of-service" />
                    <meta name="robots" content="index,follow" />
                </Helmet>

                <Navbar />
                <div className={Classes.heroContent} >
                    <div className={Classes.heading}>
                        <h1>Terms of Service</h1>
                    </div>
                    <h5>Last Updated: October 5, 2026</h5>
                    <br />
                    <h5>
                        Welcome to <a href='/' target='_blank' >quickvents.com</a>, the website of Quick Vents and Appliance Repair ("Quick Vents," "we," "us," or "our"). These Terms of Service ("Terms") govern your use of our website and the dryer vent cleaning and appliance repair services we provide in Palm Beach County, Florida (collectively, the "Services").
                        <br />
                        <br />
                        By using our website or booking our Services, you agree to these Terms.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>1. Our Services</h5>
                    <h5>
                        We provide dryer vent cleaning and appliance repair for homes and condos in Palm Beach and Broward Counties, Florida. Service availability depends on your location and our schedule.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>2. Booking and Appointments</h5>
                    <h5>
                        You can book online through our scheduling provider (Housecall Pro), by phone, or through our contact form. An appointment is confirmed once we confirm it with you. If you need to reschedule or cancel, please let us know as early as possible.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>3. Quotes and Pricing</h5>
                    <h5>Before we begin work:</h5>
                    <br />
                    <ul>
                        <li>
                            <h5>
                                Dryer vent cleaning is quoted before we start
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Appliance repairs begin with a diagnostic service call, and you receive a quote before any repair work is done
                            </h5>
                        </li>
                        <li>
                            <h5>
                                If conditions on site differ from what was described, such as hard-to-reach vents or additional damage, we will discuss any change in price with you before continuing
                            </h5>
                        </li>
                    </ul>
                    <br />
                    <h5 className={Classes.major_title}>4. Access and Safety</h5>
                    <h5>
                        Please provide safe access to the dryer, appliance, vent run, and any exterior or roof vent terminations. We may decline or postpone work if conditions are unsafe, and we may recommend repairs or replacement when a vent or appliance cannot be serviced safely.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>5. Payment</h5>
                    <h5>
                        Payment is due when the work is completed unless we agree otherwise in writing. Accepted payment methods are listed on your invoice. Payments are processed by our third-party payment providers.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>6. Warranties</h5>
                    <h5>
                        Any warranty on our labor or on parts we supply will be stated on your invoice. Parts may also be covered by the manufacturer's warranty. Except as stated on your invoice or required by law, the Services are provided without additional warranties.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>7. Limitation of Liability</h5>
                    <h5>
                        To the fullest extent permitted by law, Quick Vents is not liable for indirect, incidental, or consequential damages arising from the Services or your use of our website. Our total liability for any claim related to a service will not exceed the amount you paid for that service. Nothing in these Terms limits liability that cannot be limited under Florida law.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>8. Calls, Texts, and Emails</h5>
                    <h5>
                        By giving us your phone number or email address, you agree that we may contact you about your appointment, quote, or service. You can opt out of non-essential messages at any time by replying STOP to a text or contacting us.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>9. Use of Our Website</h5>
                    <h5>
                        The content on our website is for general information and may change without notice. You agree not to misuse the website or interfere with its operation. The website's content, logos, and design belong to Quick Vents and may not be copied without permission.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>10. Third-Party Services</h5>
                    <h5>
                        Our website links to third-party services, including our online booking page (Housecall Pro), Google, Facebook, Instagram, and Yelp. We are not responsible for the content or practices of those services, and their own terms apply.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>11. Privacy</h5>
                    <h5>
                        Our <a href='/privacy-policy' target='_blank' >Privacy Policy</a> explains how we collect and use your information.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>12. Changes to These Terms</h5>
                    <h5>
                        We may update these Terms from time to time. When we do, we will update the date at the top of this page. Your continued use of our website or Services after an update means you accept the revised Terms.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>13. Governing Law</h5>
                    <h5>
                        These Terms are governed by the laws of the State of Florida, without regard to its conflict of law principles. Any dispute will be handled in the state or federal courts located in Palm Beach County, Florida.
                    </h5>
                    <br />
                    <h5 className={Classes.major_title}>14. Contact Us</h5>
                    <h5>
                        If you have any questions about these Terms, please contact us at:
                        <br /><br />
                        Quick Vents and Appliance Repair
                        <br />23257 FL-7 #216, Boca Raton, FL 33428
                        <br />(561) 929-5476
                        <br />support@quickvents.com
                    </h5>
                    <br />

                </div>

            </form>
            <Footer />
        </>
    )
}
